import React from "react";
import { Dialog, DialogContent, DialogTitle } from "./ui/dialog";

export default function VideoDialog({ videoUrl, open, onOpenChange }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="w-[92vw] max-w-4xl p-0 border-0 bg-transparent shadow-none">
        <DialogTitle className="sr-only">CMED.AI video</DialogTitle>
        <div className="w-full aspect-video overflow-hidden rounded-2xl bg-black shadow-2xl">
          {open && videoUrl && (
            <video
              src={videoUrl}
              controls
              autoPlay
              playsInline
              className="h-full w-full object-contain bg-black"
            />
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
}
